import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import { remapValue } from '../../Common/Utils';
import { EngineEvents } from '../../Constants/Events';
import { GameModel } from '../../Models/GameModel';
import { SoundModel } from '../../Models/SoundModel';

export interface SettingBarOptions {
    bar: 0 | 1,
}

export class SettingsBarController extends AnimationBaseController {
    $model: GameModel;
    private factor = 0;
    private active = false;

    constructor(
        @Inject private options: SettingBarOptions,
        @Inject private events: ModelEvents,
    ) {
        super('SettingsBarController');
    }

    getConfiguration(): IAnimationControllerConfiguration {
        return {
            onPointerDown: () => {
                this.active = true;
                this.setFactor(this.factor);
            },
            onPointerMove: (pointer) => {
                const bounds = this.display.getBounds();

                this.factor = (pointer.globalPosition.x - bounds.x) / bounds.width;
                if (this.active)
                    this.setFactor(this.factor);
            },
            onPointerUp: () => {
                this.active = false;
            },
            onPointerUpOutside: () => {
                this.active = false;
            },
        };
    }

    onInitialize() {
        if (this.options.bar) {
            this.setFactor(SoundModel.music_level, false);

        } else {
            this.setFactor(SoundModel.fx, false);
        }
    }

    setFactor(factor: number = 0, save: boolean = true) {
        factor = parseFloat(factor.toFixed(3));

        if (factor > 1) factor = 1;
        if (factor < 0) factor = 0;

        this.gotoAndStop(Math.round(remapValue(factor, 0, 1, 0, 27)));

        if (save) {
            if (this.options.bar) {
                SoundModel.setMusicLevel(factor);

            } else {
                SoundModel.setFxLevel(factor);
            }
        }

        this.events.dispatch(this.$model, EngineEvents.musicLoudness);
    }

}
